// class used to read all elements properties from a specific view

import { ElementModelId, modelIdToKey } from "./TemplatesAndCollections";

export class PropertiesManager {
    constructor() {
        this.properties = new Object();
        this.modelsMap = new Object(); // hold the source model for each object
        this.viewerIdToModelId = new Object();
        this.modelIdToViewerId = new Object();
        this.levels = new Object();

    }

    // viewer - forge viewer
    // ids - list of ids from the viewer open model to load properties from
    async loadElements(viewer, ids) {
        var loadedModelName = viewer.model
            .getData()
            .loadOptions.bubbleNode.getRootNode()
            .children[0].name();
        var externalIdMapping = await getExternalIdMappingAsync(viewer.model);



        var links = new Object();

        var propsArr = await getAllPropertiesAsync(ids, viewer);

        for (var i = 0; i < ids.length; i++) {
            var props = propsArr[i];
            if (props == null) continue;
            this.properties[ids[i]] = props;

            var revitId = RevitIdFromProperties(props);

            var linkId = 0;
            var externalIds = props.externalId.split("/");
            var modelName = loadedModelName;

            if (revitId != null && externalIds.length > 1) {
                var linkInstanceId = externalIds[0];

                var dbId = externalIdMapping[linkInstanceId];

                if (links[dbId] == null)
                    links[dbId] = await getPropertiesAsync(dbId, viewer);
                var linkNameProp = links[dbId].properties.find(
                    (prop) =>
                        prop.displayName == "Type Name"
                );
                if (linkNameProp && linkNameProp.displayValue != null)
                    modelName = linkNameProp.displayValue;
                else modelName = "Unknown";

                linkId = RevitIdFromProperties(links[dbId]);
                if (linkId == null)
                    linkId = 0;
            }

            if (revitId == null)
                revitId = ids[i];

            var newId = new ElementModelId(linkId, revitId);
            this.viewerIdToModelId[ids[i]] = newId;
            this.modelIdToViewerId[modelIdToKey(newId)] = ids[i];

            this.modelsMap[ids[i]] = modelName;
        }
    }

    async loadLevels(viewer, modelId) {
        var props = this.properties[modelId];
        var levels = props.properties.filter(
            (prop) => (prop.attributeName == "Level" || prop.displayName == "Level") && prop.hidden == true
        );

        for (var i = 0; i < levels.length; i++) {
            var levelId = levels[i].displayValue;
            if (levelId != null && Number.isInteger(levelId)) {
                var levelProps = await getPropertiesAsync(levelId, viewer);
                if (levelProps != null && levelProps.name != null)
                    this.levels[levelId] = levelProps.name;
            }
        }
    }

    GetProperties(id) {
        return this.properties[id];
    }

    GetModel(id) {
        return this.modelsMap[id];
    }
}

const IdsGetSize = 1000;

async function getAllPropertiesAsync(dbIds, viewer) {
    var resArr = [];
    for (var i = 0; i < dbIds.length; i += IdsGetSize) {
        var piece = dbIds.slice(i, i + IdsGetSize);
        var resPiece = await getBulkPropertiesAsync(piece, viewer);
        resArr.push(resPiece);
    }
    var res = resArr.flat();
    return res;
}


async function getBulkPropertiesAsync(dbIds, viewer) {
    return new Promise((resolve, reject) => {
        viewer.model.getBulkProperties(
            dbIds,
            null,
            result => resolve(result),
            error => reject(error)
        );
    });
}

// get properties of a model element from his viewer ID
async function getPropertiesAsync(dbId, viewer) {
    return new Promise((resolve, reject) => {
        viewer.getProperties(
            dbId,
            (result) => resolve(result),
            (error) => reject(error)
        );
    });
}

// Get id mappings for linked elements in model
async function getExternalIdMappingAsync(model) {
    return new Promise((resolve, reject) => {
        model.getExternalIdMapping(
            (map) => resolve(map),
            (error) => reject(error)
        );
    });
}


function RevitIdFromProperties(props) {
    try {
        var res = props.name.split("[");
        if (res.length < 2)
            return null;
        var stringResult = res[1].split("]")[0];
        if (stringResult.toLowerCase().includes("e"))
            return null;
        var result = +stringResult;
        return Number.isInteger(result) ? result : null;
    }
    catch (e) {
        return null;
    }
}

